<template>
  <a-modal
    :visible="visible"
    title="团队话题"
    :maskClosable="false"
    :width="600"
    :destroyOnClose="true"
    @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-item v-show="!onlyMember" label="聊天室名称">
        <a-input
          v-decorator="[
            'name',
            {
              rules: [{ required: true, message: '请输入聊天室名称' }],
              initialValue: formData.name
            }
          ]"
          placeholder="请输入聊天室名称"
        />
      </a-form-item>
      <a-form-item label="团队成员">
        <VSelect
        v-decorator="[
            'members',
            {
              rules: [{ required: true, message: '请选择团队成员' }],
              initialValue: formData.members
            }
          ]"
        :maxTagCount="1"
        :options="membersList"
        :optionsFields="{ value: 'user_id', label: 'user_name' }"
        placeholder="请选择团队成员"
        @change="handleSelectChange($event)"
        @clearValue="() => formData.members = []"
        mode="multiple"
      />
      </a-form-item>
      <a-form-item v-show="!onlyMember" label="团队模板">
        <a-checkbox-group
          v-decorator="[
            'templates',
            {
              initialValue: formData.templates || []
            }
          ]"
          :style="{ width: '100%', marginTop: '10px' }"
        >
          <div v-if="templatesLoading" class="template-loading">
            <a-spin size="small" />
            <span class="loading-text">加载中...</span>
          </div>
          <div v-else-if="teamTemplatesList.length === 0" style="margin-top: -2px;">
            暂无模板
          </div>
          <a-row v-else>
            <a-col :span="24" v-for="item in teamTemplatesList" :key="item.team_prompt_id" class="template-item">
              <div class="template-item-content">
                <a-checkbox :value="item.team_prompt_id">{{ item.title }}</a-checkbox>
                <div class="template-item-actions">
                  <a-tooltip title="编辑">
                    <a-icon type="edit" class="template-action-icon" @click="editTemplate(item)" />
                  </a-tooltip>
                  <a-tooltip title="删除">
                    <a-icon type="delete" class="template-action-icon" @click="deleteTemplate(item)" />
                  </a-tooltip>
                </div>
              </div>
            </a-col>
          </a-row>
        </a-checkbox-group>
        <a class="team-topic-add-template" @click="showTemplateModal" v-if="teamTemplatesList.length < 10">
          <a-icon type="plus" /> 新增团队模板
        </a>
        <div class="template-limit-tip" v-else>
          <a-icon type="info-circle" /> 最多添加10个团队模板
        </div>
      </a-form-item>
      <!-- 当从个人话题转为团队话题时显示清空历史消息选项 -->
      <a-form-item v-if="sourceSessionId" label="个人转团队">
        <a-checkbox
          v-decorator="[
            'clearHistory',
            {
              valuePropName: 'checked',
              initialValue: true
            }
          ]"
        >
          把当前会话转为团队话题并清空历史聊天消息
        </a-checkbox>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" :loading="confirmLoading" @click="handleSubmit">确定</a-button>
    </template>

    <!-- 团队模板弹窗 -->
    <team-template-modal
      :visible="templateModalVisible"
      :loading="templateConfirmLoading"
      :formData="templateFormData"
      @cancel="handleTemplateCancel"
      @submit="handleTemplateSubmit"
    />
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import TeamTemplateModal from './TeamTemplateModal'
import VSelect from '@/components/VSelect'
export default {
  name: 'TeamTopicModal',
  components: {
    TeamTemplateModal,
    VSelect
  },
  data() {
    return {
      onlyMember: false,
      visible: false,
      confirmLoading: false,
      formData: {
        name: '',
        members: [],
        templates: [],
        clearHistory: true
      },
      form: this.$form.createForm(this),
      templatesLoading: false,
      templateModalVisible: false,
      templateConfirmLoading: false,
      templateFormData: {
        title: '',
        content: '',
        team_prompt_id: undefined
      },
      isEditingTemplate: false,
      currentTeamTopicId: null,
      sourceSessionId: null
    }
  },
  computed: {
    ...mapGetters('aiAssistant', ['$aiHttp', 'membersList', 'teamTemplatesList'])
  },
  watch: {
    visible(val) {
      if (val) {
        this.$store.dispatch('aiAssistant/send', {
          method: 'getUsers',
          data: {}
        })
        this.$store.dispatch('aiAssistant/send', {
          method: 'getTeamPrompts',
          data: {}
        })
      }
    }
  },
  methods: {
    handleSelectChange (value) {
      this.formData.members = value
    },
    tagPlaceholder(tags) {
      return `+${tags.length}`
    },
    open (item, onlyMember) {
      this.sourceSessionId = item.sourceSessionId || null
      this.onlyMember = onlyMember
      if (item) {
        if (!item.sourceSessionId) {
          this.currentTeamTopicId = item.session_id
          this.formData = {
            name: item.title,
            templates: item.teamPrompts ? item.teamPrompts.map(item => item.team_prompt_id) : [],
            members: item.partakeUsers || []
          }
        } else {
          this.currentTeamTopicId = null
          this.formData = {
            name: item.title || '',
            templates: [],
            members: []
          }
        }
      } else {
        this.currentTeamTopicId = null
        this.formData = {
          name: '',
          templates: [],
          members: []
        }
      }
      this.visible = true
    },
    // 提交表单
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (err) return
        try {
          this.confirmLoading = true
          // 处理模板数据
          const data = {
            type: 'teamSession',
            title: values.name,
            partake_users: this.membersList.filter(item => this.formData.members.find(member => member.user_id === item.user_id)),
            team_prompt_ids: this.form.getFieldValue('templates') || []
          }

          if (this.sourceSessionId) {
            this.$store.dispatch('aiAssistant/send', {
              method: 'convertSession',
              data: {
                session_id: this.sourceSessionId,
                is_his: values.clearHistory ? 1 : 0,
                ...data
              }
            })
          } else if (this.currentTeamTopicId) {
            this.$store.dispatch('aiAssistant/send', {
              method: 'editSession',
              data: {
                session_id: this.currentTeamTopicId,
                ...data
              }
            })
          } else {
            this.$store.dispatch('aiAssistant/send', {
              method: 'addSession',
              data
            })
          }

          this.visible = false
          this.$message.success('操作成功')
        } catch (error) {
          console.error('操作失败:', error)
          this.$message.error('操作失败')
        } finally {
          this.confirmLoading = false
        }
      })
    },
    // 取消
    handleCancel() {
      this.form.resetFields()
      this.$emit('cancel')
      this.formData = {
        name: '',
        members: [],
        templates: [],
        clearHistory: true
      }
      this.visible = false
    },
    // 显示团队模板弹窗
    showTemplateModal() {
      if (this.teamTemplatesList.length >= 10) {
        this.$message.warning('最多添加10个团队模板')
        return
      }
      this.templateModalVisible = true
      this.templateFormData = {
        title: '',
        content: '',
        team_prompt_id: undefined
      }
      this.isEditingTemplate = false
    },
    // 编辑团队模板
    editTemplate(template) {
      this.templateModalVisible = true
      this.templateFormData = {
        title: template.title,
        content: template.content,
        team_prompt_id: template.team_prompt_id
      }
      this.isEditingTemplate = true
    },
    // 删除团队模板
    deleteTemplate(template) {
      if (!template.is_haveing) {
        this.$message.warning('非自己创建模板，无法删除')
        return
      }
      this.$confirm({
        title: '确认删除',
        content: `确定要删除模板"${template.title}"吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.$store.dispatch('aiAssistant/send', {
            method: 'delTeamPrompt',
            data: {
              team_prompt_id: template.team_prompt_id
            }
          })
          this.form.setFieldsValue({
            templates: this.form.getFieldValue('templates').filter(item => item !== template.team_prompt_id)
          })
          this.$message.success('删除团队模板成功')
          setTimeout(() => {
             // 刷新模板列表
          this.$store.dispatch('aiAssistant/send', {
            method: 'getTeamPrompts',
            data: {}
          })
          }, 500)
        }
      })
    },
    // 取消团队模板弹窗
    handleTemplateCancel() {
      this.templateModalVisible = false
    },
    // 提交团队模板
    async handleTemplateSubmit(values) {
      if (this.teamTemplatesList.length >= 10 && !this.isEditingTemplate) {
        this.$message.warning('最多添加10个团队模板')
        return
      }

      const data = {
        ...values
      }

      if (this.isEditingTemplate) {
        data.team_prompt_id = this.templateFormData.team_prompt_id
        this.$store.dispatch('aiAssistant/send', {
          method: 'editTeamPrompt',
          data
        })
        this.$message.success('更新团队模板成功')
      } else {
        this.$store.dispatch('aiAssistant/send', {
          method: 'addTeamPrompt',
          data
        })
        this.$message.success('添加团队模板成功')
      }
      this.handleTemplateCancel()
      setTimeout(() => {
        this.$store.dispatch('aiAssistant/send', {
        method: 'getTeamPrompts',
        data: {}
      })
      }, 500)
    }
  }
}
</script>

<style lang="less" scoped>
.team-topic {
  &-add-template {
    display: block;
    color: #1890ff;
  }
}
.template {
  &-loading, &-empty {
    padding: 8px 0;
    color: rgba(0, 0, 0, 0.45);
  }
  &-loading {
    display: flex;
    align-items: center;
    .loading-text {
      margin-left: 8px;
    }
  }
  &-item {
    margin-bottom: 8px;

    &-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &-actions {
      display: flex;
      gap: 8px;
    }
  }
  &-action-icon {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.45);

    &:hover {
      color: #1890ff;
    }
  }
  &-limit-tip {
    margin-top: 8px;
    color: #faad14;
  }
}
</style>
